<div fxLayout="column" fxFlexFill>

    <div class="divider layout-padd-2 title-filter-date" ngClass.xs="layout-padd-5" #pageTitle>

        <span class="mat-title">API LOGS</span>

    </div>

    <div fxFlex class="scrolled">

        <div class="scrolled-y">

            <table mat-table matSort [dataSource]="dataSource" class="full-w clicked" ngClass.xs="fix-w-table">

                <ng-container matColumnDef="api_route_date">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>  {{"clientAccount.Date" | translate}} </th>
                    <td mat-cell *matCellDef="let log">
                        {{log.api_route_date | dateFilter:"DD-MM-YYYY HH:mm"}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="api_route">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{"clientAccount.Action" | translate}} </th>
                    <td mat-cell *matCellDef="let log">
                        <mat-chip-list>
                            <mat-chip [class.warn]="log.api_route === 'delete'" [class.dark]="log.api_route === 'last_login'" [class.primary]="log.api_route === 'update'" [class.great]="log.api_route === 'create'">
                                {{log.api_route | uppercase}}
                            </mat-chip>
                        </mat-chip-list>
                    </td>
                </ng-container>

                <ng-container matColumnDef="api_route_type">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{"clientAccount.Type" | translate}} </th>
                    <td mat-cell *matCellDef="let log">{{log.api_route_type | capitalize}} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{"clientAccount.Description" | translate}} </th>
                    <td mat-cell *matCellDef="let log" [matTooltip]="log.description">{{log.description | descFilter:40}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <div fxLayoutAlign="center center" class="layout-padd" *ngIf="!loaders.logs && dataSource.data.length < 1">
                <span class="mat-subheading-1">{{"clientAccount.noLog" | translate}}</span>
            </div>

            <app-popup-loader [flagLoading]="loaders.logs" [size]="30" [statusMessage]="'loaderText.logs'|translate" [type]="'line'"></app-popup-loader>

        </div>

    </div>

    <mat-paginator [pageSize]="pageSize"></mat-paginator>

</div>